/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FirmwareLookupTableOnAzure,
  FirmwareLookupTableUpdate,
} from '../models/index';
import {
    FirmwareLookupTableOnAzureFromJSON,
    FirmwareLookupTableOnAzureToJSON,
    FirmwareLookupTableUpdateFromJSON,
    FirmwareLookupTableUpdateToJSON,
} from '../models/index';

export interface ApiFirmwareLookupTableUpdatePutRequest {
    firmwareLookupTableUpdate?: FirmwareLookupTableUpdate;
}

/**
 * 
 */
export class FirmwareLookupTableApi extends runtime.BaseAPI {

    /**
     */
    async apiFirmwareLookupTableGetGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FirmwareLookupTableOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/FirmwareLookupTable/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwareLookupTableOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiFirmwareLookupTableGetGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FirmwareLookupTableOnAzure> {
        const response = await this.apiFirmwareLookupTableGetGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFirmwareLookupTableGetManufacturingFirmwareVersionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FirmwareLookupTableOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/FirmwareLookupTable/GetManufacturingFirmwareVersion`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwareLookupTableOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiFirmwareLookupTableGetManufacturingFirmwareVersionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FirmwareLookupTableOnAzure> {
        const response = await this.apiFirmwareLookupTableGetManufacturingFirmwareVersionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFirmwareLookupTableUpdatePutRaw(requestParameters: ApiFirmwareLookupTableUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/FirmwareLookupTable/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareLookupTableUpdateToJSON(requestParameters['firmwareLookupTableUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFirmwareLookupTableUpdatePut(requestParameters: ApiFirmwareLookupTableUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiFirmwareLookupTableUpdatePutRaw(requestParameters, initOverrides);
    }

}
